import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { IconButton, Toolbar, Typography } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import CustomTable from "./CustomTable";
import DatePicker from "./DatePicker";
import { UserDataContext } from "../Contexts/UserDataContext";
import { downloadData } from "../GlobalFunctions";

const WeeklyAuditPage = () => {
  const [searchDate, setSearchDate] = useState(null);
  const [rawData, setRawData] = useState([]);

  const { userData } = useContext(UserDataContext);

  useEffect(() => {
    axios({
      method: "GET",
      url: "Audit/GetWeeklyAuditData",
      headers: {
        "content-type": "application/json",
        Authorization: userData.token && `bearer ${userData.token}`,
      },
    }).then((res) => {
      console.log(res.data);
      setRawData(
        res.data.map((x) => ({
          ...x,
          weekStartDate: new Date(x.weekStartDate),
          weekEndDate: new Date(x.weekEndDate),
        }))
      );
    });
  }, [userData.token]);

  // const rawData = [
  //   {
  //     weekStartDate: new Date("2020-09-13"),
  //     weekEndDate: new Date("2020-09-19"),
  //     nOustanding: 0,
  //     outStandingCSV: false,
  //     unibis: true,
  //   },
  //   {
  //     weekStartDate: new Date("2020-09-06"),
  //     weekEndDate: new Date("2020-09-12"),
  //     nOustanding: 5,
  //     outStandingCSV: true,
  //     unibis: true,
  //   },
  // ];

  const data =
    searchDate == null ? rawData : rawData.filter((x) => x.weekStartDate <= searchDate && searchDate <= x.weekEndDate);

  return (
    <CustomTable
      title="Weekly Audit Page"
      defaultAlign="center"
      defaultSort={false}
      components={{
        Toolbar: (props) => (
          <Toolbar>
            <Typography variant="h6">{props.title}</Typography>
            <div style={{ flexGrow: 1 }} />
            <DatePicker label="Specific Date" onChange={setSearchDate} value={searchDate} />
          </Toolbar>
        ),
      }}
      columns={[
        {
          title: "Week Start Date",
          field: "weekStartDate",
          render: (row) => row.weekStartDate.toLocaleDateString("en-NZ"),
        },
        {
          title: "Week End Date",
          field: "weekEndDate",
          render: (row) => row.weekEndDate.toLocaleDateString("en-NZ"),
        },
        {
          title: "Number Outstanding",
          field: "outstandingCount",
          render: (row) => (row.outstandingCount ? row.outstandingCount : "-"),
        },
        {
          title: "Outstanding CSV",
          field: "outstandingFileName",
          render: (row) =>
            row.outstandingFileName ? (
              <IconButton
                onClick={() => {
                  axios({
                    method: "GET",
                    url: "Files/DownloadOutstanding/" + row.outstandingFileName,
                    headers: {
                      "content-type": "application/json",
                      Authorization: userData.token && `bearer ${userData.token}`,
                    },
                  }).then((res) => {
                    downloadData(res.data);
                  });
                }}
              >
                <GetApp />
              </IconButton>
            ) : (
              "-"
            ),
        },
        {
          title: "Unibis File",
          field: "unibisFileName",
          render: (row) =>
            row.unibisFileName ? (
              <IconButton
                onClick={() => {
                  axios({
                    method: "GET",
                    url: "Files/DownloadUnibis/" + row.unibisFileName,
                    headers: {
                      "content-type": "application/json",
                      Authorization: userData.token && `bearer ${userData.token}`,
                    },
                  }).then((res) => {
                    downloadData(res.data);
                  });
                }}
              >
                <GetApp />
              </IconButton>
            ) : (
              "-"
            ),
        },
      ]}
      data={data}
    />
  );
};

export default WeeklyAuditPage;
